// TODO: 更新 dayjs 到 ESModule
const dayjs = require('dayjs');
const objectSupport = require('dayjs/plugin/objectSupport');
const duration = require('dayjs/plugin/duration');
dayjs.extend(objectSupport);
dayjs.extend(duration);

import { getSearchUrlParams } from '@utils/utils';
import { I_SeekDestination } from '@interfaces/api/searchinfo';

interface I_Params {
    device: 'PC' | 'M';
    mCloseBtn?: (isOpen: boolean) => void;
}
export const createSearchPanel = ({ device, mCloseBtn }: I_Params) => {
    new window.SearchPanel({
        panel: 'flightSearch',
        type: `${device.toLocaleLowerCase()}`,
        target: '_blank',
        rowSkin: true,
        mTitle: '搜尋引擎',
        mCloseBtn: function () {
            mCloseBtn && mCloseBtn(false);
        },
        searchPaneltDidMount: function () {
            console.log('Search Panel ready!!');
        },
        whenSubmitBtnClick: function () {
            console.log('when Submit Button on Click!!');
        },
        renderNode: `searchpanel${device}`,
    });
};

export const getItineraryUrlParams = () => {
    const urlParams = new URLSearchParams(location.search);
    const seekArr: I_SeekDestination[] = [];
    const depDates: string[] = [];

    let missingParams = false;

    urlParams.forEach((_, key) => {
        if (key.match(/^DepDate/)) depDates.push(key);
    });

    // 如果沒有給日期就預設去回程
    if (depDates.length === 0) {
        depDates.push('DepDate1', 'DepDate2');
        missingParams = true;
    }

    depDates.forEach((depDate, i) => {
        let date: string;

        const seqNum = i + 1;
        const autoInitDate = dayjs().add(60, 'day').add(i * 7, 'day').format('YYYY-MM-DD'); // 標準網址帶預設值
        const curDate = urlParams.get(depDate) ?? `${autoInitDate}`;
        const isToday = dayjs().isSame(curDate, 'day');
        const isBeforeToday = dayjs().isBefore(curDate, 'day');

        if (seqNum === 1) {
            // 第一段日期 : 如果 <= 今天，帶入今天
            if (isToday || isBeforeToday) {
                date = curDate;
            } else {
                date = dayjs().add(60, 'day').format('YYYY-MM-DD');
                missingParams = true;
            }
        } else {
            // 第二段之後日期 : 如果 < 上一個日期，帶入上一個日期 +7
            const prevDate = seekArr[seqNum - 2].DepartDate;
            const isBeforePrevDate = dayjs(curDate).isBefore(prevDate, 'day');

            if (isBeforePrevDate) {
                date = dayjs()
                    .add(60, 'day')
                    .add(i * 7, 'day')
                    .format('YYYY-MM-DD');
                missingParams = true;
            } else {
                date = curDate;
            }
        }

        // 如果url 沒有回程參數，就把寫去程參數寫到返回
        const seekObj = {
            DepartDate: date,
            DepartCity: urlParams.get(`DepCity${seqNum}`) ?? urlParams.get(`ArrCity${seqNum - 1}`) ?? '',
            DepartAirport: urlParams.get(`Depart${seqNum}`) ?? urlParams.get(`Arrive${seqNum - 1}`) ?? '',
            DepartCountry: urlParams.get(`DepCountry${seqNum}`) ?? urlParams.get(`ArrCountry${seqNum - 1}`) ?? '',
            ArriveCity: urlParams.get(`ArrCity${seqNum}`) ?? urlParams.get(`DepCity${seqNum - 1}`) ?? '',
            ArriveAirport: urlParams.get(`Arrive${seqNum}`) ?? urlParams.get(`Depart${seqNum - 1}`) ?? '',
            ArriveCountry: urlParams.get(`ArrCountry${seqNum}`) ?? urlParams.get(`DepCountry${seqNum - 1}`) ?? '',
        };

        if (!urlParams.get(`DepCity${seqNum}`) || !urlParams.get(`ArrCity${seqNum}`)) {
            missingParams = true;
        }

        seekArr.push(seekObj);
    });

    const searchParams = getSearchUrlParams();

    // 如果缺失參數，在這邊新增上去
    if (missingParams) {
        // Reload the URL with the default parameters
        const newUrlParams = new URLSearchParams(location.search);

        depDates.forEach((depDate, i) => {
            newUrlParams.set(depDate, seekArr[i].DepartDate);
        });
        seekArr.forEach((seek, i) => {
            const seqNum = i + 1;
            newUrlParams.set(`DepCity${seqNum}`, seek.DepartCity);
            newUrlParams.set(`ArrCity${seqNum}`, seek.ArriveCity);
            newUrlParams.set(`Depart${seqNum}`, seek.DepartAirport!);
            newUrlParams.set(`Arrive${seqNum}`, seek.ArriveAirport!);
            newUrlParams.set(`DepCountry${seqNum}`, seek.DepartCountry);
            newUrlParams.set(`ArrCountry${seqNum}`, seek.ArriveCountry);
        });

        // Add other necessary parameters
        newUrlParams.set('PreferAirlines', searchParams.PreferAirlines!);
        newUrlParams.set('SeekLcc', searchParams.SeekLcc!);
        newUrlParams.set('Rtow', searchParams.Rtow);
        newUrlParams.set('ClsType', searchParams.ClsType);
        newUrlParams.set('Adt', searchParams.Adt.toString());
        newUrlParams.set('Chd', searchParams.Chd.toString());
        newUrlParams.set('Inf', searchParams.Inf.toString());
        newUrlParams.set('NoTrans', searchParams.NoTrans ? 'T' : 'F');
        newUrlParams.set('Platform', 'APP');

        const newUrl = `${location.pathname}?${newUrlParams.toString()}`;
        window.location.replace(newUrl);
        return; // Stop execution after reload
    }

    return { ...searchParams, SeekDestinations: seekArr };
};

interface IRoute {
    href: string | undefined;
    text: string;
}
export const getRoutes = (SearchPrice: any): IRoute[] => {
    //取回API回來的資料 第一筆目的地城市
    const countryLink = () => {
        const hasSearchResult = SearchPrice.data && SearchPrice.data.FlightInfos?.length > 0;

        let cityName = '搜尋結果頁';
        if (!SearchPrice.isLoading && hasSearchResult) {
            cityName = SearchPrice.data.FlightInfos[0].ItineraryInfos[0].ArrCityName + '機票';
        }

        return { href: undefined, text: cityName };
    };

    const routes = [
        {
            href: getHomeDomain(),
            text: '雄獅首頁',
        },

        {
            href: getFlightDomain(),
            text: '國際機票',
        },
        countryLink(),
    ];

    return routes;
};

function getHomeDomain() {
    switch (process.env.ENV) {
        case 'prod':
            return '//www.liontravel.com/category/zh-tw/index';
        default:
            return '//uwww.liontravel.com/category/zh-tw/index';
    }
}

function getFlightDomain() {
    switch (process.env.ENV) {
        case 'prod':
            return '//flight.liontravel.com/category/zh-tw/index';
        default:
            return '//uflight.liontravel.com/category/zh-tw/index2';
    }
}
